import {
  APIURL,
  client,
  atAPIOptions,
} from './at-app-api';

export const atGetUserInfo = () => {
  const request = client();
  return request.get(
      `${APIURL}/api/userinfo/admin`
  );
};

// Fetch user by username (returns array, expect first match)
export const atGetUserByUsername = (username: string) => {
  const request = client();
  return request.get(
    `${APIURL}/api/user`,
    { params: { username } }
  );
};

export const atSignAgreement = (data: any) => {

  const request = client();
  return request.post(
    `${APIURL}/api/userinfo/sign`,
    data,
  );
};

export const atImportTherapistsCsv = (data: any) => {
  const request = client();
  return request.post(
    `${APIURL}/api/user/import-csv`,
    data,
  );
};

